import {getQueryString, uuid} from "@common/utils";
import { RPC } from '@mixer/postmessage-rpc';
import {nioJsBridge} from "@nio-wad/universal-bridge-h5";
import {getEnv} from "@/client/env";

export const setupIframeBridge = (iframeEl, serviceId = uuid()) => {
    const rpc = new RPC({
        target: iframeEl.contentWindow,
        serviceId,
    });
    rpc.expose('callBridge', (res) => {
        try {
            const method = nioJsBridge[res.method]
            if (typeof method === 'function') {
                if(res.method==='getUserInfo'){
                    // 如果url中有token，优先使用url中的token
                    const queryToken = decodeURIComponent(getQueryString('token',window.location.href) || '');
                    if(queryToken){
                        return Promise.resolve({
                            result_code: 'success',
                            data: {
                                access_token: queryToken,
                            }
                        })
                    }
                    return method({
                        data:{
                            uniLogin:true,
                            env:getEnv(),
                            ...res.data?.data
                        }
                    })
                }
                return method(res.data);
            } else {
                throw new Error('method not found or not callable');
            }
        } catch (error) {
            return {
                result_code: 'error',
                error_type: 'unknown_error',
                display_message: error?.message || 'method not found',
                data: error,
        }
        }
    })

    return () => {
        rpc.destroy();
    }
};
